const INSIGHTS_SORT_LIST_COMMON = {
  'most_recent.desc': 'most_recent.descending',
  'most_recent.asc': 'most_recent.ascending',
  'engagement_rate.desc': 'engagement_rate.descending',
  'engagement_rate.asc': 'engagement_rate.ascending',
  'likes.desc': 'likes.descending',
  'likes.asc': 'likes.ascending',
  'comments.desc': 'comments.descending',
  'comments.asc': 'comments.ascending'
};

export const INSIGHTS_SORT_LIST_INSTAGRAM = {
  ...INSIGHTS_SORT_LIST_COMMON,
  'followers.desc': 'followers.descending',
  'followers.asc': 'followers.ascending'
};

export const INSIGHTS_SORT_LIST_YOUTUBE = {
  ...INSIGHTS_SORT_LIST_COMMON,
  'subscribers.desc': 'subscribers.descending',
  'subscribers.asc': 'subscribers.ascending'
};
